import React, { useContext } from 'react';
import { getGuestCard } from '../../../../../api/TourSignup';
import { useFetch } from '../../../../../hooks/useFetch';
import { LoadingDisplay } from '../../../../common/LoadingOverlay';
import { ConfirmationSection } from './ConfirmationSection';
import { PropertyContext } from '../TourRouter';
import GuestCardLoadFailureDisplay from '../display/GuestCardLoadFailureDisplay';
import GuestCardDisplay from '../display/GuestCardDisplay';

const GuestCardConfirmationSection = (props: { guestCardGuid: string }) => {
    const property = useContext(PropertyContext);
    if (!property) {
        return null;
    }

    const { data, error, loading } = useFetch(
        () => getGuestCard(property.id, props.guestCardGuid),
        [],
        undefined
    );

    let display = loading ? (
        <LoadingDisplay />
    ) : !data || error ? (
        <GuestCardLoadFailureDisplay error={error} />
    ) : (
        <GuestCardDisplay guestCard={data} />
    );

    return (
        <ConfirmationSection
            headerText="My Info"
            hasIssue={loading ? undefined : !data || error ? true : false}
        >
            {display}
        </ConfirmationSection>
    );
};

export default GuestCardConfirmationSection;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/confirmation/GuestCardConfirmationSection.tsx